module.exports = __webpack_public_path__ + "img/information.48805e98.svg";